import React, { useState, useEffect } from "react";
import { Modal, Row, Col, Button } from "react-bootstrap";
import { InputField } from "../../../../Components/formElements/InputField";

const QualityCheckModal = ({
  show,
  onHide,
  qcType,          // "PHYSICAL" | "SPECIFICATION"
  rowData,         // selected GRN row
  onSaveQualityCheck, // callback to parent
}) => {

  /* ---------------- STATE ---------------- */
  const [qcForm, setQcForm] = useState({
    packagingCondition: "",
    physicalDamage: "",
    quantityVerified: "",
    inspectionRemarks: "",

    modelMatch: "",
    brandMatch: "",
    sizeGradeMatch: "",
    technicalParamsOk: "",
  });

  /* -------- RESET FORM WHEN MODAL OPENS -------- */
  // useEffect(() => {
  //   if (show) {
  //     setQcForm({
  //       packagingCondition: "",
  //       physicalDamage: "",
  //       quantityVerified: "",
  //       inspectionRemarks: "",
  //       modelMatch: "",
  //       brandMatch: "",
  //       sizeGradeMatch: "",
  //       technicalParamsOk: "",
  //     });
  //   }
  // }, [show]);

  useEffect(() => {
  if (show && rowData) {
    setQcForm({
      // ----- PHYSICAL
      packagingCondition: rowData.packagingCondition || "",
      physicalDamage: rowData.physicalDamage || "",
      quantityVerified: rowData.quantityVerified || "",
      inspectionRemarks: rowData.inspectionRemarks || "",

      // ----- SPECIFICATION
      modelMatch: rowData.modelMatch || "",
      brandMatch: rowData.brandMatch || "",
      sizeGradeMatch: rowData.sizeGradeMatch || "",
      technicalParamsOk: rowData.technicalParamsOk || "",
    });
  }
}, [show, rowData]);


  /* ---------------- ON CHANGE ---------------- */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setQcForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  /* ---------------- SAVE ---------------- */
  const handleSave = () => {
    const payload = {
      qcType,
      grnItemNr: rowData?.grnItemNr,
      grnNumber: rowData?.grnNr,
      materialCode: rowData?.materialCode,
      materialDescription: rowData?.materialDescription,
      grnQuantity: rowData?.grnQuantity,
      mrPrice: rowData?.mrPrice,
      ...qcForm,
    };

    // send data to parent
    onSaveQualityCheck(payload);

    // close modal
    onHide();
  };

  /* ---------------- UI ---------------- */
  return (
    <Modal show={show} onHide={onHide} size="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>
          {qcType === "PHYSICAL" && "Physical Verification"}
          {qcType === "SPECIFICATION" && "Specification Check"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* -------- GRN INFO -------- */}
        <Row className="mb-3">
          <Col md={3}>
            <strong>GRN Item :</strong> {rowData?.grnItemNr}
          </Col>
          <Col md={3}>
            <strong>Material Code :</strong> {rowData?.materialCode}
          </Col>
          <Col md={3}>
            <strong>Material :</strong> {rowData?.materialDescription}
          </Col>
          <Col md={3}>
            <strong>Quantity :</strong> {rowData?.grnQuantity}
          </Col>
          <Col md={3}>
            <strong>mrPrice :</strong> {rowData?.mrPrice}
          </Col>
        </Row>

        {/* -------- PHYSICAL VERIFICATION -------- */}
        {qcType === "PHYSICAL" && (
          <>
            <Row className="mb-3 ">
              <Col md={6} className="commTopButtonRightLeftPadding">
                <InputField
                  className="inputBox"
                  label="Packaging Condition"
                  name="packagingCondition"
                  value={qcForm.packagingCondition}
                  onChange={handleChange}
                  
                />
              </Col>
              <Col md={6} className="commTopButtonRightLeftPadding">
                <InputField
                  className="inputBox"
                  label="Physical Damage"
                  name="physicalDamage"
                  value={qcForm.physicalDamage}
                  onChange={handleChange}
                />
              </Col>
            </Row>

            <Row className="mb-3" >
              <Col md={6} className="commTopButtonRightLeftPadding">
                <InputField
                  className="inputBox"
                  label="Quantity Verified"
                  name="quantityVerified"
                  value={qcForm.quantityVerified}
                  onChange={handleChange}
                />
              </Col>
              <Col md={6} className="commTopButtonRightLeftPadding">
                <InputField
                  className="inputBox"
                  label="Inspection Remarks"
                  name="inspectionRemarks"
                  value={qcForm.inspectionRemarks}
                  onChange={handleChange}
                />
              </Col>
            </Row>
          </>
        )}

        {/* -------- SPECIFICATION CHECK -------- */}
        {qcType === "SPECIFICATION" && (
          <>
            <Row className="mb-3">
              <Col md={6} className="commTopButtonRightLeftPadding">
                <InputField
                  className="inputBox"
                  label="Model Matches PO"
                  name="modelMatch"
                  value={qcForm.modelMatch}
                  onChange={handleChange}
                />
              </Col>
              <Col md={6} className="commTopButtonRightLeftPadding">
                <InputField
                  className="inputBox"
                  label="Brand Matches PO"
                  name="brandMatch"
                  value={qcForm.brandMatch}
                  onChange={handleChange}
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6} className="commTopButtonRightLeftPadding">
                <InputField
                  className="inputBox"
                  label="Size / Grade Match"
                  name="sizeGradeMatch"
                  value={qcForm.sizeGradeMatch}
                  onChange={handleChange}
                />
              </Col>
              <Col md={6} className="commTopButtonRightLeftPadding">
                <InputField
                  className="inputBox"
                  label="Technical Parameters OK"
                  name="technicalParamsOk"
                  value={qcForm.technicalParamsOk}
                  onChange={handleChange}
                />
              </Col>
            </Row>
          </>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default QualityCheckModal;
